module.exports = {
  API: '/api/v1',
  // API: 'http://208.75.74.63:3000/api/v1',
}